// extracted by mini-css-extract-plugin
export default {"dragImagesLabel":"Footer_dragImagesLabel__wNduq"};